import { useFetchBeeswaxCampaigns } from "./useBeeswaxCampaigns";

export const useBeeswaxCampaign = (id: string | undefined) => {
  const { data: campaigns, isLoading } = useFetchBeeswaxCampaigns();
  const campaign = campaigns?.find(c => c.id === id);

  return { data: campaign, isLoading };
};
